const getRegionData = (region) =>
  regions.find((r) => r.value === region) ||
  regions.find((r) => r.default === true) ||
  regions[0];

// used by the registration form
const regions = [
  {
    label: 'selectRegion', // for i18n
    value: 0,
    apiURL: '',
    imgURL: '',
  },
  ...window.apiRegions,
];

export { regions, getRegionData };



// WEBPACK FOOTER //
// ./src/constants/regions.js